import { datadogRum } from '@datadog/browser-rum';

const env = process.env.REACT_APP_ENV ?? 'development';

if (env !== 'development') {
  const revision = process.env.REACT_APP_GIT_SHA ?? 'unknown';

  datadogRum.init({
    applicationId: '46bd3b93-72b3-435a-8640-56d127257f34',
    clientToken: 'pubab359e83d039218e1f93cf483862887b',
    site: 'datadoghq.com',
    service: 'pullrequest',
    env,
    version: revision,
    sampleRate: 100,
    trackInteractions: false,
  });
}
